import { useEffect, useRef, useState } from "react";
import axios from "axios";

import { debugLog, errorLog } from "./debugUtils";
import { filterObjectsByProperty } from "./dataUtils";

export const isTestEnv = typeof global !== "undefined" && global.__RAVEN_TEST__;

// variables of Read Only / Edit access for User/Groups
export const ACLs = [
	{ id: 201, type: "group", access: "edit", value: 2 },
	{ id: 202, type: "user", access: "edit", value: 2 },
	{ id: 203, type: "group", access: "read", value: 1 },
	{ id: 204, type: "user", access: "read", value: 1 },
];

export function getQueryVariable(variable) {
	var query = window.location.search.substring(1);
	// console.log(query); //"app=article&act=news_content&aid=160990"
	var vars = query.split("&");
	// console.log(vars); //[ 'app=article', 'act=news_content', 'aid=160990' ]

	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split("=");
		// console.log(pair);
		//[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ]

		if (pair[0].toLowerCase() === variable.toLowerCase()) {
			return pair[1];
		}
	}
	return false;
}

const apiBase = (() => {
	const apiBaseEnv = (process.env.REACT_APP_API_BASE_URL || "").trim().replace(/\/$/, "");
	const serverUri = (process.env.REACT_APP_SERVER_URI || "").trim().replace(/\/$/, "");
	if (apiBaseEnv) return apiBaseEnv; // e.g. "/api" or "https://host/api"
	if (serverUri) return `${serverUri}/api`; // e.g. "https://host/api"
	return "/api"; // same-origin default
})();

// Reload lookups from sessionStorage
export async function reloadLookupsFromDB(resetApp = false) {
	try {
		if (!sessionStorage.hasOwnProperty("lookups") || resetApp) {
			debugLog(2, "[appUtils][FLOW] reloadLookupsFromDB started", { resetApp: resetApp });

			// Await make wait until that
			// promise settles and return its result
			await axios
				.get(
					// Prefer same-origin unless REACT_APP_SERVER_URI is set
					`${apiBase}/load`,
					{
						headers: {
							"Content-type": "application/json",
						},
						withCredentials: true,
					},
				)
				.then((response) => {
					debugLog(3, "[appUtils][STATE] load API response", { response: response });

					// sessionStorage.setItem("lookups", JSON.stringify(response.data));
					let lookups = response.data;
					if (typeof lookups !== "object" || lookups === null) {
						errorLog(2, "[appUtils][FLOW] /api/load returned non-object", {
							receivedType: typeof lookups,
						});
						lookups = {};
					}

					// lookups.USER_ROLES = filterObjectsByProperty(lookups.ALL, "type_id", 101);
					lookups.BL_CFG_TYPES = filterObjectsByProperty(lookups.BL_LOOKUPS_ALL, "group_id", 100);
					lookups.BL_CFG_ACCESSES = filterObjectsByProperty(
						lookups.BL_LOOKUPS_ALL,
						"group_id",
						200,
					);
					lookups.BL_ITEM_OPT_TYPES = filterObjectsByProperty(
						lookups.BL_LOOKUPS_ALL,
						"group_id",
						300,
					);
					lookups.BL_ITEM_OPTS = filterObjectsByProperty(lookups.BL_LOOKUPS_ALL, "group_id", 400);
					lookups.BL_ITEM_DETAILS = filterObjectsByProperty(
						lookups.BL_LOOKUPS_ALL,
						"group_id",
						500,
					);
					sessionStorage.setItem("lookups", JSON.stringify(lookups));

					debugLog(3, "[appUtils][STATE] lookups saved to sessionStorage", {});
				});

			await axios
				.get("https://api.ipify.org/?format=json")
				.then((res) => {
					debugLog(2, "[appUtils][FLOW] ip fetch succeeded", { ip: res.data?.ip });

					sessionStorage.setItem("ip", JSON.stringify(res.data.ip));
				})
				.catch((error) => {
					console.error("Error:", error);
				});
		}
	} catch (error) {
		errorLog(2, "[appUtils][FLOW] reloadLookupsFromDB failed", { error: error });
	}
}

export const useEffectOnce = (effect) => {
	const destroyFunc = useRef();
	const calledOnce = useRef(false);
	const renderAfterCalled = useRef(false);

	if (calledOnce.current) {
		renderAfterCalled.current = true;
	}

	useEffect(() => {
		if (calledOnce.current) {
			return;
		}

		calledOnce.current = true;
		destroyFunc.current = effect();

		return () => {
			if (!renderAfterCalled.current) {
				return;
			}

			if (destroyFunc.current) {
				destroyFunc.current();
			}
		};

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};

export const useIsFirstRender = () => {
	const [isFirst, setIsFirst] = useState(true);
	useEffect(() => {
		setIsFirst(false);
	}, []);
	return isFirst;
};
